<div class="">
    <app-main-navbar></app-main-navbar>
    <!--<app-fixed-socials></app-fixed-socials>-->
    <app-openings-card></app-openings-card>
    <app-footer></app-footer>
</div>